export type Pgm31aTransferLevelCd = "F1" | "FO2" | "FE2";

type Pgm31aTransferProgram =
  | {
      curriculumVersion?: string | null;
      level?: number | null;
      levelCode?: string | null;
    }
  | null
  | undefined;

export type Pgm31aTransferCopy = {
  actionLabel: string;
  tooltipTitle: string;
  headline: string;
  destination: string;
  keepClassicCourseworkNote: string;
};

const F1_COPY: Pgm31aTransferCopy = {
  actionLabel: "Transfer to Automated Portfolio",
  tooltipTitle: "Eligible for transfer to the Automated Facility Management Portfolio.",
  headline: "Transfer to Automated Facility Management Portfolio",
  destination: "the Automated Facility Management Portfolio",
  keepClassicCourseworkNote: ""
};

const FO2_COPY: Pgm31aTransferCopy = {
  actionLabel: "Transfer to Automated Portfolio",
  tooltipTitle: "Eligible for transfer to the Automated Facility Management and Teaching & Coaching Portfolios.",
  headline: "Transfer to Automated Portfolios",
  destination: "the Automated Facility Management and Teaching & Coaching Portfolios",
  keepClassicCourseworkNote: " Coursework and seminar requirements stay in place."
};

const FE2_COPY: Pgm31aTransferCopy = {
  actionLabel: "Transfer to Automated Portfolio",
  tooltipTitle: "Eligible for transfer to the Automated Portfolio.",
  headline: "Transfer to Automated Portfolio",
  destination: "the Automated Portfolio",
  keepClassicCourseworkNote: " Coursework and seminar requirements stay in place."
};

export function pgm31aTransferLevelCd(program: Pgm31aTransferProgram): Pgm31aTransferLevelCd | null {
  if (program?.curriculumVersion !== "3.1") return null;

  const code = program.levelCode?.trim().toUpperCase();
  if (program.level === 1 && (!code || code === "F1")) return "F1";
  if (program.level === 2 && (code === "FO2" || code === "FE2")) return code;

  return null;
}

export function pgm31aTransferCopy(levelCd: Pgm31aTransferLevelCd): Pgm31aTransferCopy {
  if (levelCd === "FO2") return FO2_COPY;
  if (levelCd === "FE2") return FE2_COPY;
  return F1_COPY;
}
